var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPrivacyLockIcon = function SvgPrivacyLockIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5904",
    "data-name": "Grupo 5904",
    transform: "translate(-571 -729)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1991",
    "data-name": "Ret\\xE2ngulo 1991",
    width: 30,
    height: 30,
    transform: "translate(571 729)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4530",
    "data-name": "Caminho 4530",
    d: "M21,9.5H19.785V7.071a6.071,6.071,0,0,0-12.142,0V9.5H6.428A2.436,2.436,0,0,0,4,11.928V24.07A2.436,2.436,0,0,0,6.428,26.5H21a2.436,2.436,0,0,0,2.428-2.428V11.928A2.436,2.436,0,0,0,21,9.5ZM13.714,20.427A2.428,2.428,0,1,1,16.142,18,2.436,2.436,0,0,1,13.714,20.427ZM17.478,9.5H9.95V7.071a3.764,3.764,0,0,1,7.528,0Z",
    transform: "translate(572 730)",
    fill: "#c1c1c1"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPrivacyLockIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/privacy-lock-icon.a32efc63.svg";
export { ForwardRef as ReactComponent };